import React, {Fragment, useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import FMPFileExport from "../FileExport/FMPFileExport";

export default function IPSFMPViewType(props) {
    const { onViewTypeChange, tabView, tstatus} = props;
    const [viewType, setViewType] = useState('cardview');

    let listIconStyle = {
      fontSize: 30,
      cursor: "pointer",
      color: viewType === 'cardview' ? "#c0c0c0" : "black"
    };
    let cardIconStyle = {
      fontSize: 30,
      cursor: "pointer",
      color: viewType === 'cardview' ? "black" : "#c0c0c0"
    };

    function onClick(event, viewType) {
        setViewType(viewType);
        onViewTypeChange(viewType);
    }

    return (
        <Fragment>
            <FontAwesomeIcon
                icon="th"
                style={cardIconStyle}
                onClick={(event) => onClick(event, "cardview")}
            />
            <span className="space-20"/>
            <FontAwesomeIcon
                icon="list"
                style={listIconStyle}
                onClick={(event) => onClick(event, "listview")}
            />
            <span className="space-20"/>
            <FMPFileExport tabView={tabView} fmpstatus={ tstatus} />
        </Fragment>
    )
}